import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import BillDetails from './components/BillDetails';
import PaymentConfirm from './components/PaymentConfirm';
import PaymentSuccess from './components/PaymentSuccess';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/billers-page" element={<BillDetails />} />
        <Route path="/payment-confirm" element={<PaymentConfirm />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        {/* Add more routes here */}
      </Routes>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
